import React, { useState, Suspense } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { VisitorParamsProvider } from "./Contexts/VisitorParams";
import HomePage from "./Components/Pages/HomePage";
import { RedirectProvider } from "./Contexts/RedirectContext";
import "./App.scss";
// import AdtopiaLoadDynamic from "./Utility/AdtopiaLoadDynamic";

// import EnvDocView from "./Components/Pages/MYCG_V1/EnvDocView";
import HelmetBasedOnDomain from "./Components/Includes/Layouts/Common/HelmetBasedOnDomain";

const AdtopiaLoadDynamic = React.lazy(
  () => import('./Utility/AdtopiaLoadDynamic')
);

const MYCG_V1 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V1"));

const MycgV1PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V1/MycgV1PersonalDetails")
);

const MycgV1Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_V1/MycgV1Signature")
);
const MycgV1IdUpload = React.lazy(() =>
  import("./Components/Pages/MYCG_V1/MycgV1IdUpload")
);
const MycgV1CarRegistration = React.lazy(() =>
  import("./Components/Pages/MYCG_V1/MycgV1CarRegistration")
);
// const MycgV1Lenders = React.lazy(() =>
//   import("./Components/Pages/MYCG_V1/MycgV1Lenders")
// );

const MycgV1LendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_V1/MycgV1LendersComponentSelection")
);

const MycgV1EligibleLenders = React.lazy(() =>
  import("./Components/Pages/MYCG_V1/MycgV1EligibleLenders")
);

const FbPixel = React.lazy(() => import("./Components/Pages/FbPixel"));
const MycgV1Thankyou = React.lazy(() =>
  import("./Components/Pages/MYCG_V1/MycgV1Thankyou")
);
// const MycgV1CreditAnalysis = React.lazy(() =>
//   import("./Components/Pages/MYCG_V1/MycgV1CreditAnalysis")
// );

const MycgV1CreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V1/MycgV1CreditAnalysisLoader")
);

const Loader = React.lazy(() =>
  import("./Components/Includes/Layouts/Loader/Loader")
);

const NoWinNoFee = React.lazy(() =>
  import("./Components/Includes/Layouts/Footer/NoWinNoFee")
);
const ComplaintsPolicy = React.lazy(() =>
  import("./Components/Includes/Layouts/Footer/ComplaintsPolicy")
);

const EditUserDetailsPage = React.lazy(() =>
  import("./Components/Pages/MYCG_V1/EditUserDetailsPage")
);

// MYCG-V1B
const MYCG_V1B = React.lazy(() => import("./Components/Pages/Splits/MYCG_V1B"));

const MycgV1BPersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V1B/MycgV1BPersonalDetails")
);

const MycgV1BSignature = React.lazy(() =>
  import("./Components/Pages/MYCG_V1B/MycgV1BSignature")
);

// mycg-v1C
const MYCG_V1C = React.lazy(() => import("./Components/Pages/Splits/MYCG_V1C"));

const MycgV1CPersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V1C/MycgV1CPersonalDetails")
);

const MycgV1CSignature = React.lazy(() =>
  import("./Components/Pages/MYCG_V1C/MycgV1CSignature")
);

const MycgV1CLenders = React.lazy(() =>
  import("./Components/Pages/MYCG_V1C/MycgV1CLenders")
);

const MycgV1CCreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V1C/MycgV1CCreditAnalysisLoader")
);

// MYCG_OBV1
const MYCG_OBV1 = React.lazy(() =>
  import("./Components/Pages/Splits/MYCG_OBV1")
);

// MYCG_OBV1C
const MYCG_OBV1C = React.lazy(() =>
  import("./Components/Pages/Splits/MYCG_OBV1C")
);

// followup
const Followup = React.lazy(() =>
  import("./Components/Pages/Followup/Followup")
);

const FollowupMycgV1Signature = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_V1/FollowupMycgV1Signature")
);

// mycg_v1b
const FollowupMycgV1BSignature = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_V1B/FollowupMycgV1Signature")
);

const FollowupMycgV1IdUpload = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_V1/FollowupMycgV1IdUpload")
);
const FollowupMycgV1CarRegistration = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_V1/FollowupMycgV1CarRegistration")
);
// const FollowupMycgV1Lenders = React.lazy(() =>
//   import("./Components/Pages/Followup/MYCG_V1/FollowupMycgV1Lenders")
// );

// const FollowupMycgV1CreditAnalysis = React.lazy(() =>
//   import("./Components/Pages/Followup/MYCG_V1/FollowupMycgV1CreditAnalysis")
// );

const FollowupMycgV1CreditAnalysisLoader = React.lazy(() =>
  import(
    "./Components/Pages/Followup/MYCG_V1/FollowupMycgV1CreditAnalysisLoader"
  )
);

const FollowupMycgV1LendersComponentSelection = React.lazy(() =>
  import(
    "./Components/Pages/Followup/MYCG_V1/FollowupMycgV1LendersComponentSelection"
  )
);

const FollowupMycgV1EligibleLenders = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_V1/FollowupMycgV1EligibleLenders")
);

const FlpEditUserDetailsPage = React.lazy(() =>
  import("./Components/Pages/Followup/FlpEditUserDetailsPage")
);

// mycg-v1c followup
const FollowupMycgV1CSignature = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_V1C/FollowupMycgV1Signature")
);

const FollowupMycgV1CLenders = React.lazy(() =>
  import(
    "./Components/Pages/Followup/MYCG_V1C/FollowupMycgV1LendersCreditFailed"
  )
);

const FollowupMycgV1CCreditAnalysisLoader = React.lazy(() =>
  import(
    "./Components/Pages/Followup/MYCG_V1C/FollowupMycgV1CreditAnalysisLoader"
  )
);

const MycgIDdUploadV2 = React.lazy(() =>
  import("./Components/Pages/MYCG_V1/MycgIDdUploadV2")
);
// MYCGV2

const MYCG_V2 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V2"));

const MycgV2PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V2/MycgV2PersonalDetails")
);

const MycgV2Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_V2/MycgV2Signature")
);

const MycgV2CreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V2/MycgV2CreditAnalysisLoader")
);

const MycgV2LendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_V2/MycgV2LendersComponentSelection")
);

const MycgV2IdUpload = React.lazy(() =>
  import("./Components/Pages/MYCG_V2/MycgV2IdUpload")
);

const EditUserDetailsPageV2 = React.lazy(() =>
  import("./Components/Pages/MYCG_V2/EditUserDetailsPageV2")
);


const MycgV2CarRegistration = React.lazy(() =>
  import("./Components/Pages/MYCG_V2/MycgV2CarRegistration")
);

const MycgV2EligibleLenders = React.lazy(() =>
  import("./Components/Pages/MYCG_V2/MycgV2EligibleLenders")
);

const MycgV2Thankyou = React.lazy(() =>
  import("./Components/Pages/MYCG_V2/MycgV2Thankyou")
);

const Privacy = React.lazy(() =>
  import("./Components/Pages/Privacy")
);


// MYCGV3

const MYCG_V3 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V3"));

const MycgV3PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V3/MycgV3PersonalDetails")
);

const MycgV3CreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V3/MycgV3CreditAnalysisLoader")
);

const MycgV3LendersComponentSelection = React.lazy(() => import('./Components/Pages/MYCG_V3/MycgV3LendersComponentSelection'));

const MycgV3EligibleLenders = React.lazy(() =>
  import("./Components/Pages/MYCG_V3/MycgV3EligibleLenders")
);

const EditUserDetailsPageV3 = React.lazy(() =>
  import("./Components/Pages/MYCG_V3/EditUserDetailsPageV3")
);

const MycgV3CarRegistration = React.lazy(() =>
  import("./Components/Pages/MYCG_V3/MycgV3CarRegistration")
);

const MycgV3IdUpload = React.lazy(() =>
  import("./Components/Pages/MYCG_V3/MycgV3IdUpload")
);
const MycgV3IDdUploadV2 = React.lazy(() =>
  import("./Components/Pages/MYCG_V3/MycgV3IDdUploadV2")
);

const MycgV3Thankyou = React.lazy(() =>
  import("./Components/Pages/MYCG_V3/MycgV3Thankyou")
);


const FollowupIdUploadV2 = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_V1/FollowupIdUploadV2")
);

//Followup Pending Id Upload
const FollowupID = React.lazy(() =>
  import("./Components/Pages/Followup/FollowupID")
);


// shorturl followup(from cake)
const FollowupV2 = React.lazy(() =>
  import("./Components/Pages/Followup/FollowupV2")
);

//MYcgV5
const MYCG_V5 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V5"));

const MycgV5PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V5/MycgV5PersonalDetails")
);

const MycgV5Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_V5/MycgV5Signature")
);

const MycgV5CreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V5/MycgV5CreditAnalysisLoader")
);

const MycgV5LendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_V5/MycgV5LendersComponentSelection")
);

const EditUserDetailsPageV5 = React.lazy(() =>
  import("./Components/Pages/MYCG_V5/EditUserDetailsPage")
);

//MYcgV5B
const MYCG_V5B = React.lazy(() => import("./Components/Pages/Splits/MYCG_V5B"));

const MycgV5BPersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V5B/MycgV5BPersonalDetails")
);

const MycgV5BSignature = React.lazy(() =>
  import("./Components/Pages/MYCG_V5B/MycgV5BSignature")
);

const MycgV5BCreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V5B/MycgV5BCreditAnalysisLoader")
);

const MycgV5BLendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_V5B/MycgV5BLendersComponentSelection")
);

const EditUserDetailsPageV5B = React.lazy(() =>
  import("./Components/Pages/MYCG_V5B/EditUserDetailsPageV5B")
);

// MYCG_OB_V6

const MYCG_OB_V6 = React.lazy(() => import("./Components/Pages/Splits/MYCG_OB_V6"));

const MYCGOBV6PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_OB_V6/MYCGOBV6PersonalDetails")
);

const MycgOBV6Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_OB_V6/MycgOBV6Signature")
);

const MycgOBV6CreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_OB_V6/MycgOBV6CreditAnalysisLoader")
);

const MycgOBV6LendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_OB_V6/MycgOBV6LendersComponentSelection")
);

const EditUserDetailsPageV6 = React.lazy(() =>
  import("./Components/Pages/MYCG_OB_V6/EditUserDetailsPage")
);
//MYcgV6B
const MYCG_OB_V6B = React.lazy(() => import("./Components/Pages/Splits/MYCG_OB_V6B"));

const MycgV6BPersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V6B/MycgV6BPersonalDetails")
);

const MycgV6BSignature = React.lazy(() =>
  import("./Components/Pages/MYCG_V6B/MycgV6BSignature")
);

const MycgV6BCreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V6B/MycgV6BCreditAnalysisLoader")
);

const MycgV6BLendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_V6B/MycgV6BLendersComponentSelection")
);

const EditUserDetailsPageV6B = React.lazy(() =>
  import("./Components/Pages/MYCG_V6B/EditUserDetailsPageV6B")
);

// MYCG_V7

const MYCG_V7 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V7"));

const MYCGV7PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V7/MycgV7PersonalDetails")
);

const MycgV7Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_V7/MycgV7Signature")
);

const MycgV7CreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V7/MycgV7CreditAnalysisLoader")
);

const MycgV7LendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_V7/MycgV7LendersComponentSelection")
);

const EditUserDetailsPageV7 = React.lazy(() =>
  import("./Components/Pages/MYCG_V7/EditUserDetailsPage")
);

// MYCG_TB_V1
const MYCG_TB_V1 = React.lazy(() => import("./Components/Pages/Splits/MYCG_TB_V1"));

const MycgTBV1PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_TB_V1/MycgTBV1PersonalDetails")
);

const MycgTBV1Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_TB_V1/MycgTBV1Signature")
);

// MYCG_TB_V5
const MYCG_TB_V5 = React.lazy(() => import("./Components/Pages/Splits/MYCG_TB_V5"));

const MycgTBV5PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_TB_V5/MycgTBV5PersonalDetails")
);
const MycgTBV5Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_TB_V5/MycgTBV5Signature")
);
const MYCG_TB_V5B = React.lazy(() => import("./Components/Pages/Splits/MYCG_TB_V5B"));

const MycgTBV5BPersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_TB_V5B/MycgTBV5BPersonalDetails")
);

const MycgTBV5BSignature = React.lazy(() =>
  import("./Components/Pages/MYCG_TB_V5B/MycgTBV5BSignature")
);

//MYCG_V5C
const MYCG_V5C = React.lazy(() => import("./Components/Pages/Splits/MYCG_V5C"));

const MycgV5CPersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V5C/MycgV5CPersonalDetails")
);

const MycgV5CSignature = React.lazy(() =>
  import("./Components/Pages/MYCG_V5C/MycgV5CSignature")
);

//MYCG_V5D
const MYCG_V5D = React.lazy(() => import("./Components/Pages/Splits/MYCG_V5D"));

const MycgV5DPersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V5D/MycgV5DPersonalDetails")
);

const MycgV5DSignature = React.lazy(() =>
  import("./Components/Pages/MYCG_V5D/MycgV5DSignature")
);


// MYCG_BH_V6
const MYCG_BH_V6 = React.lazy(() => import("./Components/Pages/Splits/MYCG_BH_V6"));

const MycgBHV6PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_BH_V6/MycgBHV6PersonalDetails")
);

const MycgBHV6Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_BH_V6/MycgBHV6Signature")
);

const MycgBHV6CreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_BH_V6/MycgBHV6CreditAnalysisLoader")
);

const MycgBHV6LendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_BH_V6/MycgBHV6LendersComponentSelection")
);

// MYCG_OB_V5C
const MYCG_OB_V5C = React.lazy(() => import("./Components/Pages/Splits/MYCG_OB_V5C"));

const MycgOBV5PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_OB_V5C/MycgOBV5CPersonalDetails")
);

const MycgOBV5CSignature = React.lazy(() =>
  import("./Components/Pages/MYCG_OB_V5C/MycgOBV5CSignature")
);
// MYCG_TB_V5C
const MYCG_TB_V5C = React.lazy(() => import("./Components/Pages/Splits/MYCG_TB_V5C"));

// Flp MYCG_BH_V6

const FollowupMycgBHV6LendersComponentSelection = React.lazy(() =>
  import(
    "./Components/Pages/Followup/MYCG_BH_V6/FollowupMycgBHV6LendersComponentSelection"
  )
);

const FollowupMycgBHV6EligibleLenders = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_BH_V6/FollowupMycgBHV6EligibleLenders")
);

const FollowupMycgBHV6Signature = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_BH_V6/FollowupMycgBHV6Signature")
);

const FollowupMycgBHV6CreditAnalysisLoader = React.lazy(() =>
  import(
    "./Components/Pages/Followup/MYCG_BH_V6/FollowupMycgBHV6CreditAnalysisLoader"
  )
);

const FlpEditUserDetailsPageBHV6 = React.lazy(() =>
  import("./Components/Pages/Followup/FlpEditUserDetailsPageBHV6")
);
// MYCG_V8 

const MYCG_V8 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V8"));

const MYCGV8PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V8/UserCreatePage")
);


const EditUserDetailsPageV8 = React.lazy(() =>
  import("./Components/Pages/MYCG_V8/EditUserDetailsPageV8")
);

const MycgV8LendersCreditFailed = React.lazy(() =>
  import("./Components/Pages/MYCG_V8/MycgV8LendersCreditFailed")
);


const MYCGLenderRedirectV8 = React.lazy(() =>
  import("./Components/Pages/MYCG_V8/MYCGLenderRedirectV8")
);
const MycgV8Lenders = React.lazy(() =>
  import("./Components/Pages/MYCG_V8/MycgV8Lenders")
);

const MycgV8SelectLenders = React.lazy(() =>
  import("./Components/Pages/MYCG_V8/MycgV8SelectLenders")
);

// MYCG_V5E
const MYCG_V5E = React.lazy(() => import("./Components/Pages/Splits/MYCG_V5E"));

const MycgV5EPersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V5E/MycgV5EPersonalDetails")
);

const MycgMaintenance = React.lazy(() =>
  import("./Components/Includes/Layouts/Maintenance/MycgMaintenance")
);
//Common ThankYou Page
const CommonThankYou = React.lazy(() =>
  import("./Components/Includes/Layouts/Common/CommonThankYou")
);

// MYCG_V6
const MYCG_V6 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V6"));

const MycgV6PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V6/MycgV6PersonalDetails")
);


//MYCG_V9

const MYCG_V9 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V9"));

const MycgV9PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V9/MycgV9personalDetails")
);

const MycgV9Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_V9/MycgV9Signature")
);

const MycgV9CreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V9/MycgV9CreditAnalysisLoader")
);


const MycgV9LendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_V9/MycgV9LendersComponentSelection")
);

// Skip Id Upload V9
const MycgV9IdUpload = React.lazy(() =>
  import("./Components/Pages/MYCG_V9/MycgV9IdUpload")
);


const MycgV9IdUploadV2 = React.lazy(() =>
  import("./Components/Pages/MYCG_V9/MycgV9IdUploadV2")
);

const EditUserPageV9 = React.lazy(() =>
  import("./Components/Pages/MYCG_V9/EditUserDetailsPageV9")
);

const MycgV9EligibleLenders = React.lazy(() =>
  import("./Components/Pages/MYCG_V9/MycgV9EligibleLenders")
);

//MYCG_V9_1
const MYCG_V9_1 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V9_1"));

const MycgV9_1PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V9_1/MycgV9_1personalDetails")
);

const MycgV9_1Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_V9_1/MycgV9_1Signature")
);

const MycgV9_1CreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V9_1/MycgV9_1CreditAnalysisLoader")
);

const MycgV9_1LendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_V9_1/MycgV9_1LendersComponentSelection")
);

// Skip Id Upload V9_1
const MycgV9_1IdUpload = React.lazy(() =>
  import("./Components/Pages/MYCG_V9_1/MycgV9_1IdUpload")
);

const MycgV9_1IdUploadV2 = React.lazy(() =>
  import("./Components/Pages/MYCG_V9_1/MycgV9_1IdUploadV2")
);

const EditUserPageV9_1 = React.lazy(() =>
  import("./Components/Pages/MYCG_V9_1/EditUserDetailsPageV9_1")
);

const MycgV9_1EligibleLenders = React.lazy(() =>
  import("./Components/Pages/MYCG_V9_1/MycgV9_1EligibleLenders")
);

//MYCG_V10
const MYCG_V10 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V10"));

const MycgV10PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V10/MycgV10PersonalDetails")
);

const MycgV10Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_V10/MYCGV10Signature")
);


const MycgV10CreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V10/MycgV10CreditAnalysisLoader")
);

const MycgV10LendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_V10/MycgV10LendersComponentSelection")
);
// MYCG_V11 

const MYCG_V11 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V11"));


const MycgV11CreditAnalysisLoader = React.lazy(() =>
  import("./Components/Pages/MYCG_V11/MycgV11CreditAnalysisLoader")
);

const MycgV11LendersComponentSelection = React.lazy(() =>
  import("./Components/Pages/MYCG_V11/MycgV11LendersComponentSelection")
);
const EditUserPageV11 = React.lazy(() =>
  import("./Components/Pages/MYCG_V11/EditUserDetailsPageV11")
);
// follow based on credit check client not found 
const FollowupCCV1 = React.lazy(() =>
  import("./Components/Pages/Followup/FollowupCCV1")
);

const CCFlpEditUserDetailsPage = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_CC_FLP/CCFlpEditUserDetailsPage")
);

const CCFlpCreditCheckRetryOtherReasons = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_CC_FLP/FollowupMycgCCCreditAnalysisLoader")
);
const FollowupMycgCCIdUpload = React.lazy(() =>
  import("./Components/Pages/Followup/MYCG_CC_FLP/FollowupMycgCCIdUpload")
);


const MYCG_V5C1 =  React.lazy(() => import("./Components/Pages/Splits/MYCG_V5C1"));
// MYCG_V5C2
const MYCG_V5C2 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V5C2"));
const MYCG_V5C3 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V5C3"));

const MYCG_V10B = React.lazy(() => import("./Components/Pages/Splits/MYCG_V10B")); 


//MYCG_V5C_A1
const MYCG_V5C_A1 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V5C_A1"));

const MycgV5CA1PersonalDetails = React.lazy(() =>
  import("./Components/Pages/MYCG_V5C_A1/MycgV5CA1PersonalDetails")
);

const MycgV5CA1Signature = React.lazy(() =>
  import("./Components/Pages/MYCG_V5C_A1/MycgV5CA1Signature")
);

const AdvertorialV1 = React.lazy(() => 
  import ("./Components/Pages/Advertorial/AdvertorialV1")
);

//MYCG_V5C_A2
const MYCG_V5C_A2 = React.lazy(() => import("./Components/Pages/Splits/MYCG_V5C_A2"));
const MycgV5CA2PersonalDetails = React.lazy(() => import("./Components/Pages/MYCG_V5C_A2/MycgV5CA2PersonalDetails.js"));
const MycgV5CA2Signature = React.lazy(() =>import("./Components/Pages/MYCG_V5C_A2/MycgV5CA2Signature"));
const LoaderA2 = React.lazy(() =>
  import("./Components/Includes/Layouts/Loader/LoaderA2")
);
const ThankYouNonuk = React.lazy(() =>
  import("./Components/Includes/Layouts/Common/ThankYouNonuk")
);

const App = () => {
  const [visitorParameters] = useState({ visitor_parameters: [], data: [] });
  const [redirectUrl] = useState({ redirectUrl: "" });

  return (
    <>
      <HelmetBasedOnDomain />
      <VisitorParamsProvider value={{ visitorParameters }}>
        <RedirectProvider value={{ redirectUrl }}>
          <BrowserRouter>
            <Suspense
              fallback={<div style={{ color: "#FFFFFF" }}>Loading...</div>}
            >
              <Route exact path="/" component={HomePage} />
              <Route exact path="/MYCG_V1" component={MYCG_V1} />
              <Route
                exact
                path="/mycg-v1-personal-details"
                component={MycgV1PersonalDetails}
              />
              <Route exact path="/loader" component={Loader} />

              {/* <Route
                  exact
                  path="/mycg-v1-credit-analysis"
                  component={MycgV1CreditAnalysis}
                /> */}

              <Route
                exact
                path="/mycg-v1-credit-analysis"
                component={MycgV1CreditAnalysisLoader}
              />

              <Route
                exact
                path="/mycg-v1-signature"
                component={MycgV1Signature}
              />
              <Route
                exact
                path="/mycg-v1-lenders"
                component={MycgV1LendersComponentSelection}
              />

              <Route
                exact
                path="/mycg-v1-eligible-lenders"
                component={MycgV1EligibleLenders}
              />

              <Route
                exact
                path="/mycg-v1-edit-user-details"
                component={EditUserDetailsPage}
              />

              <Route
                exact
                path="/mycg-v1-car-registration"
                component={MycgV1CarRegistration}
              />
              <Route
                exact
                path="/mycg-v1-idupload"
                component={MycgV1IdUpload}
              />
              <Route
                exact
                path="/mycg-v1-Thankyou"
                // component={MycgV1Thankyou}
                component={CommonThankYou}
              />

              {/* mycg-v1b */}
              <Route exact path="/MYCG_V1B" component={MYCG_V1B} />

              <Route
                exact
                path="/mycg-v1B-personal-details"
                component={MycgV1BPersonalDetails}
              />

              <Route
                exact
                path="/mycg-v1B-signature"
                component={MycgV1BSignature}
              />

              {/* mycg-v1c */}
              <Route exact path="/MYCG_V1C" component={MYCG_V1C} />

              <Route
                exact
                path="/mycg-v1C-personal-details"
                component={MycgV1CPersonalDetails}
              />

              <Route
                exact
                path="/mycg-v1C-lenders"
                component={MycgV1CLenders}
              />

              <Route
                exact
                path="/mycg-v1C-signature"
                component={MycgV1CSignature}
              />

              <Route
                exact
                path="/mycg-v1C-credit-analysis"
                component={MycgV1CCreditAnalysisLoader}
              />

              {/* mycg_obv1 */}
              <Route exact path="/MYCG_OBV1" component={MYCG_OBV1} />

              {/* mycg_obv1c */}
              <Route exact path="/MYCG_OBV1C" component={MYCG_OBV1C} />

              <Route exact path="/complaints" component={ComplaintsPolicy} />

              <Route exact path="/no-win-no-fee" component={NoWinNoFee} />

              <Route exact path={["/fbpixel"]} component={FbPixel} />
              {/* <Route
                exact
                path={["/:doc/:docType/:filename"]}
                component={EnvDocView}
              />
               */}
              <Route
                exact
                path={["/google", "/testing"]}
                component={AdtopiaLoadDynamic}
              />

              {/* followup */}
              <Route exact path={"/followup"} component={Followup} />
              <Route
                exact
                path="/followup/mycg-v1-credit-analysis"
                component={FollowupMycgV1CreditAnalysisLoader}
              />

              <Route
                exact
                path="/followup/mycg-v1-signature"
                component={FollowupMycgV1Signature}
              />

              {/* mycg_v1b */}
              <Route
                exact
                path="/followup/mycg-v1B-signature"
                component={FollowupMycgV1BSignature}
              />

              <Route
                exact
                path="/followup/mycg-v1-lenders"
                component={FollowupMycgV1LendersComponentSelection}
              />

              <Route
                exact
                path="/followup/mycg-v1-eligible-lenders"
                component={FollowupMycgV1EligibleLenders}
              />

              <Route
                exact
                path="/followup/mycg-v1-edit-user-details"
                component={FlpEditUserDetailsPage}
              />

              <Route
                exact
                path="/followup/mycg-v1-car-registration"
                component={FollowupMycgV1CarRegistration}
              />
              <Route
                exact
                path="/followup/mycg-v1-idupload"
                component={FollowupMycgV1IdUpload}
              />

              {/* mycg-v1c  flp*/}
              <Route
                exact
                path="/followup/mycg-v1C-lenders"
                component={FollowupMycgV1CLenders}
              />

              <Route
                exact
                path="/followup/mycg-v1C-signature"
                component={FollowupMycgV1CSignature}
              />

              <Route
                exact
                path="/followup/mycg-v1C-credit-analysis"
                component={FollowupMycgV1CCreditAnalysisLoader}
              />

              <Route
                exact
                path="/mycg-v1-iduploadV2"
                component={MycgIDdUploadV2}
              />

              {/* MYCGV2 */}
              <Route exact path="/MYCG_V2" component={MYCG_V2} />
              <Route
                exact
                path="/mycg-v2-personal-details"
                component={MycgV2PersonalDetails}
              />

              <Route
                exact
                path="/mycg-v2-signature"
                component={MycgV2Signature}
              />
              <Route
                exact
                path="/mycg-v2-credit-analysis"
                component={MycgV2CreditAnalysisLoader}
              />
              <Route
                exact
                path="/mycg-v2-lenders"
                component={MycgV2LendersComponentSelection}
              />

              <Route
                exact
                path="/mycg-v2-idupload"
                component={MycgV2IdUpload}
              />

              <Route
                exact
                path="/mycg-v2-edit-user-details"
                component={EditUserDetailsPageV2}
              />
              <Route
                exact
                path="/mycg-v2-car-registration"
                component={MycgV2CarRegistration}
              />
              <Route
                exact
                path="/mycg-v2-eligible-lenders"
                component={MycgV2EligibleLenders}
              />

              <Route
                exact
                path="/mycg-v2-Thankyou"
                component={CommonThankYou}
              />

              <Route exact path="/privacy-policy" component={Privacy} />

              <Route exact path="/fast-track-processing" component={MYCG_V1} />
              <Route exact path="/free-online-check" component={MYCG_V1} />
              <Route exact path="/5-star-rating" component={MYCG_V1} />
              <Route
                exact
                path="/register-your-refund-now"
                component={MYCG_V1}
              />

              {/* MYCGV3 */}
              <Route exact path="/MYCG_V3" component={MYCG_V3} />
              <Route
                exact
                path="/mycg-v3-personal-details"
                component={MycgV3PersonalDetails}
              />

              <Route
                exact
                path="/mycg-v3-credit-analysis"
                component={MycgV3CreditAnalysisLoader}
              />
              <Route
                exact
                path="/mycg-v3-lenders"
                component={MycgV3LendersComponentSelection}
              />
              <Route
                exact
                path="/mycg-v3-eligible-lenders"
                component={MycgV3EligibleLenders}
              />

              <Route
                exact
                path="/mycg-v3-edit-user-details"
                component={EditUserDetailsPageV3}
              />

              <Route
                exact
                path="/mycg-v3-car-registration"
                component={MycgV3CarRegistration}
              />
              <Route
                exact
                path="/mycg-v3-idupload"
                component={MycgV3IdUpload}
              />
              <Route
                exact
                path="/mycg-v3-Thankyou"
                component={CommonThankYou}
              />
              <Route
                exact
                path="/mycg-v3-iduploadV2"
                component={MycgV3IDdUploadV2}
              />
              <Route
                exact
                path="/followup/mycg-v1-iduploadV2"
                component={FollowupIdUploadV2}
              />
              <Route exact path="/followup-id" component={FollowupID} />
              <Route exact path={"/followup-v2"} component={FollowupV2} />

              <Route exact path="/MYCG_V5" component={MYCG_V5} />

              <Route
                exact
                path="/mycg-v5-personal-details"
                component={MycgV5PersonalDetails}
              />

              <Route
                exact
                path="/mycg-v5-signature"
                component={MycgV5Signature}
              />

              <Route
                exact
                path="/mycg-v5-credit-analysis"
                component={MycgV5CreditAnalysisLoader}
              />

              <Route
                exact
                path="/mycg-v5-lenders"
                component={MycgV5LendersComponentSelection}
              />

              <Route
                exact
                path="/mycg-v5-edit-user-details"
                component={EditUserDetailsPageV5}
              />

              <Route exact path="/MYCG_V5B" component={MYCG_V5B} />

              <Route
                exact
                path="/mycg-v5B-personal-details"
                component={MycgV5BPersonalDetails}
              />

              <Route
                exact
                path="/mycg-v5B-signature"
                component={MycgV5BSignature}
              />

              <Route
                exact
                path="/mycg-v5B-credit-analysis"
                component={MycgV5BCreditAnalysisLoader}
              />

              <Route
                exact
                path="/mycg-v5B-lenders"
                component={MycgV5BLendersComponentSelection}
              />

              <Route
                exact
                path="/mycg-v5B-edit-user-details"
                component={EditUserDetailsPageV5B}
              />
              {/* v6 */}

              <Route exact path="/MYCG_OB_V6" component={MYCG_OB_V6} />

              <Route
                exact
                path="/mycg-ob-v6-personal-details"
                component={MYCGOBV6PersonalDetails}
              />

              <Route
                exact
                path="/mycg-ob-v6-signature"
                component={MycgOBV6Signature}
              />
              <Route
                exact
                path="/mycg-ob-v6-credit-analysis"
                component={MycgOBV6CreditAnalysisLoader}
              />
              <Route
                exact
                path="/mycg-ob-v6-lenders"
                component={MycgOBV6LendersComponentSelection}
              />

              <Route
                exact
                path="/mycg-ob-v6-edit-user-details"
                component={EditUserDetailsPageV6}
              />

              <Route exact path="/MYCG_OB_V6B" component={MYCG_OB_V6B} />

              <Route
                exact
                path="/mycg-v6B-personal-details"
                component={MycgV6BPersonalDetails}
              />

              <Route
                exact
                path="/mycg-v6B-signature"
                component={MycgV6BSignature}
              />

              <Route
                exact
                path="/mycg-v6B-credit-analysis"
                component={MycgV6BCreditAnalysisLoader}
              />

              <Route
                exact
                path="/mycg-v6B-lenders"
                component={MycgV6BLendersComponentSelection}
              />

              <Route
                exact
                path="/mycg-v6B-edit-user-details"
                component={EditUserDetailsPageV6B}
              />
              {/* v7 */}

              <Route exact path="/MYCG_V7" component={MYCG_V7} />

              <Route
                exact
                path="/mycg-v7-personal-details"
                component={MYCGV7PersonalDetails}
              />

              <Route
                exact
                path="/mycg-v7-signature"
                component={MycgV7Signature}
              />
              <Route
                exact
                path="/mycg-v7-credit-analysis"
                component={MycgV7CreditAnalysisLoader}
              />
              <Route
                exact
                path="/mycg-v7-lenders"
                component={MycgV7LendersComponentSelection}
              />

              <Route
                exact
                path="/mycg-v7-edit-user-details"
                component={EditUserDetailsPageV7}
              />

              {/* MYCG_TB_V1 */}

              <Route exact path="/MYCG_TB_V1" component={MYCG_TB_V1} />
              <Route
                exact
                path="/mycg-tb-v1-personal-details"
                component={MycgTBV1PersonalDetails}
              />

              <Route
                exact
                path="/mycg-tb-v1-signature"
                component={MycgTBV1Signature}
              />
              {/* MYCG_TB_V5 */}
              <Route exact path="/MYCG_TB_V5" component={MYCG_TB_V5} />

              <Route
                exact
                path="/mycg-tb-v5-personal-details"
                component={MycgTBV5PersonalDetails}
              />
              <Route
                exact
                path="/mycg-tb-v5-signature"
                component={MycgTBV5Signature}
              />

              <Route
                exact
                path="/MYCG_TB_V5B"
                component={MYCG_TB_V5B}
              />

              <Route
                exact
                path="/mycg-TB-v5B-personal-details"
                component={MycgTBV5BPersonalDetails}
              />

              <Route
                exact
                path="/mycg-TB-v5B-signature"
                component={MycgTBV5BSignature}
              />

              <Route exact path="/MYCG_V5C" component={MYCG_V5C} />

              <Route
                exact
                path="/mycg-v5C-personal-details"
                component={MycgV5CPersonalDetails} />
              <Route
                exact
                path="/mycg-v5C-signature"
                component={MycgV5CSignature}
              />

              <Route exact path="/MYCG_V5D" component={MYCG_V5D} />

              <Route
                exact
                path="/mycg-v5D-personal-details"
                component={MycgV5DPersonalDetails} />
              <Route
                exact
                path="/mycg-v5D-signature"
                component={MycgV5DSignature}
              />

              <Route exact path="/MYCG_BH_V6" component={MYCG_BH_V6} />

              <Route
                exact
                path="/mycg-BH-v6-personal-details"
                component={MycgBHV6PersonalDetails}
              />


              <Route
                exact
                path="/mycg-BH-v6-signature"
                component={MycgBHV6Signature}
              />

              <Route
                exact
                path="/mycg-BH-v6-credit-analysis"
                component={MycgBHV6CreditAnalysisLoader}
              />

              <Route
                exact
                path="/mycg-BH-v6-lenders"
                component={MycgBHV6LendersComponentSelection}
              />

              <Route
                exact
                path="/MYCG_OB_V5C"
                component={MYCG_OB_V5C}
              />

              <Route
                exact
                path="/mycg-ob5C-signature"
                component={MycgOBV5CSignature}
              />

              <Route
                exact
                path="/mycg-OB-v5-personal-details"
                component={MycgOBV5PersonalDetails}
              />


              {/* MYCG_TB_V5C */}
              <Route
                exact
                path="/MYCG_TB_V5C"
                component={MYCG_TB_V5C}
              />
              <Route
                exact
                path="/followup/mycg-BH-v6-eligible-lenders"
                component={FollowupMycgBHV6EligibleLenders}
              />

              <Route
                exact
                path="/followup/mycg-BH-v6-lenders"
                component={FollowupMycgBHV6LendersComponentSelection}
              />

              <Route
                exact
                path="/followup/mycg-BH-v6-signature"
                component={FollowupMycgBHV6Signature}
              />

              <Route
                exact
                path="/followup/mycg-BH-v6-credit-analysis"
                component={FollowupMycgBHV6CreditAnalysisLoader}
              />

              <Route
                exact
                path="/followup/mycg-BH-v6-edit-user-details"
                component={FlpEditUserDetailsPageBHV6}
              />


              {/* MYCG_V8 */}

              <Route exact path="/MYCG_V8" component={MYCG_V8} />

              <Route
                exact
                path="/mycg-v8-personal-details"
                component={MYCGV8PersonalDetails}
              />

              <Route
                exact
                path="/mycg-v8-lenders"
                component={MycgV8SelectLenders}
              />

              <Route
                exact
                path="/mycg-v8-edit-user-details"
                component={EditUserDetailsPageV8}
              />
              <Route
                exact
                path="/mycg-v8-lender-redirect"
                component={MYCGLenderRedirectV8}
              />
              <Route
                exact
                path="/mycg-v8-eligible-lender"
                component={MycgV8Lenders}
              />
              <Route
                exact
                path="/mycg-v8-lenders-failed"
                component={MycgV8LendersCreditFailed}
              />

              <Route
                exact
                path="/MYCG_V5E"
                component={MYCG_V5E}
              />

              <Route
                exact
                path="/mycg-v5E-personal-details"
                component={MycgV5EPersonalDetails}
              />

              <Route
                exact
                path="/site-under-maintenance"
                component={MycgMaintenance}
              />
              <Route exact path="/mycg-ThankyouV2" component={CommonThankYou} />
              {/* MYCG_V6*/}
              <Route exact path="/MYCG_V6" component={MYCG_V6} />
              <Route
                exact
                path="/mycg-v6-personal-details"
                component={MycgV6PersonalDetails}
              />

              <Route exact path="/MYCG_V9" component={MYCG_V9} />

              <Route
                exact
                path="/mycg-v9-personal-details"
                component={MycgV9PersonalDetails}
              />

              <Route
                exact
                path="/mycg-v9-signature"
                component={MycgV9Signature}
              />

              <Route
                exact
                path="/mycg-v9-credit-analysis"
                component={MycgV9CreditAnalysisLoader}
              />

              <Route
                exact
                path="/mycg-v9-lenders"
                component={MycgV9LendersComponentSelection}
              />

              <Route
                exact
                path="/mycg-v9-Idupload"
                component={MycgV9IdUpload}
              />

              <Route
                exact
                path="/mycgV9-IduploadV2"
                component={MycgV9IdUploadV2}
              />

              <Route
                exact
                path="/mycg-v9-edit-user-details"
                component={EditUserPageV9}
              />

              <Route
                exact
                path="/mycg-v9-eligible-lenders"
                component={MycgV9EligibleLenders}
              />

              {/* MYCG_V9_1*/}
              <Route exact path="/MYCG_V9_1" component={MYCG_V9_1} />

              <Route
                exact
                path="/mycg-v9_1-personal-details"
                component={MycgV9_1PersonalDetails}
              />

              <Route
                exact
                path="/mycg-v9_1-signature"
                component={MycgV9_1Signature}
              />

              <Route
                exact
                path="/mycg-v9_1-credit-analysis"
                component={MycgV9_1CreditAnalysisLoader}
              />

              <Route
                exact
                path="/mycg-v9_1-lenders"
                component={MycgV9_1LendersComponentSelection}
              />

              <Route
                exact
                path="/mycg-v9_1-Idupload"
                component={MycgV9_1IdUpload}
              />

              <Route
                exact
                path="/mycgV9_1-IduploadV2"
                component={MycgV9_1IdUploadV2}
              />

              <Route
                exact
                path="/mycg-v9_1-edit-user-details"
                component={EditUserPageV9_1}
              />

              <Route
                exact
                path="/mycg-v9_1-eligible-lenders"
                component={MycgV9_1EligibleLenders}
              />

              <Route exact path="/MYCG_V10" component={MYCG_V10} />

              <Route
                exact
                path="/mycg-v10-personal-details"
                component={MycgV10PersonalDetails}
              />

              <Route
                exact
                path="/mycg-v10-signature"
                component={MycgV10Signature}
              />

              <Route
                exact
                path="/mycg-v10-credit-analysis"
                component={MycgV10CreditAnalysisLoader}
              />


              <Route
                exact
                path="/mycg-v10-lenders"
                component={MycgV10LendersComponentSelection}
              />

              {/* MYCG_V11 */}
              
              <Route exact path="/MYCG_V11" component={MYCG_V11} />


              <Route
                exact
                path="/mycg-v11-credit-analysis"
                component={MycgV11CreditAnalysisLoader}
              />


              <Route
                exact
                path="/mycg-v11-lenders"
                component={MycgV11LendersComponentSelection}
              />

              <Route
                exact
                path="/mycg-v11-edit-user-details"
                component={EditUserPageV11}
              />
             {/* follow based on credit check client not found */}
              <Route
                exact
                path="/followup-cc-v1"
                component={FollowupCCV1}
              />
               <Route
                exact
                path="/followup/cc-flp-edit-userdetails-page"
                component={CCFlpEditUserDetailsPage}
              />
              <Route
                exact
                path="/followup/cc-flp-creditcheck-retry-otherreasons"
                component={CCFlpCreditCheckRetryOtherReasons}
              />
               <Route
                exact
                path="/followup/mycg-cc-idupload"
                component={FollowupMycgCCIdUpload}
              />


              <Route
                exact
                path="/MYCG_V5C1"
                component={MYCG_V5C1}  
              />

              <Route 
                exact 
                path="/MYCG_V5C2"
                component={MYCG_V5C2} 
              />
              <Route exact path="/MYCG_V5C3" component={MYCG_V5C3} />

                <Route exact path="/MYCG_V10B" component={MYCG_V10B} />

                {/* MYCG_V5C_A1 */}

                <Route exact path="/MYCG_V5C_A1" component={MYCG_V5C_A1} />

              <Route
                exact
                path="/mycg-v5C-personal-details-a1"
                component={MycgV5CA1PersonalDetails} />
              <Route
                exact
                path="/mycg-v5C-signature-a1"
                component={MycgV5CA1Signature}
              />
               <Route
                exact
                path="/art_2025/MYCG_ADV1"
                component={AdvertorialV1}
              />
               
                {/* MYCG_V5C_A2 */}
                <Route exact path="/MYCG_V5C_A2" component={MYCG_V5C_A2} />
                <Route exact path="/mycg-v5C-personal-details-a2" component={MycgV5CA2PersonalDetails} />
                <Route exact path="/mycg-v5C-signature-a2" component={MycgV5CA2Signature}/>
                <Route exact path="/loader-a2" component={LoaderA2} />
                <Route exact path="/mycg-Thankyou-V3" component={ThankYouNonuk} />


              {/* CMHRdomainSetup */}

              <Route
                exact
                path="/CMSH_V1"
                component={MYCG_V5C}
              />
              <Route
                exact
                path="/LUFP_OBV1C"
                component={MYCG_V5C}
              />
              <Route
                exact
                path="/LUFP_TB_V1D"
                component={MYCG_V5C}
              />
               <Route
                exact
                path="/LUFP_V1"
                component={MYCG_V5C}
              />
              <Route
                exact
                path="/LUFP_V1B"
                component={MYCG_V5C}
              />
             
             
            </Suspense>
          </BrowserRouter>
        </RedirectProvider>
      </VisitorParamsProvider>
    </>
  );
};

export default App;
